import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import AppShell from "./components/AppShell";
import Dashboard from "./pages/Dashboard";
import SketchStudio from "./pages/SketchStudio";
import MaterialStudio from "./pages/MaterialStudio";
import CollectionStudio from "./pages/CollectionStudio";
import BulkStudio from "./pages/BulkStudio";
import TryOnStudio from "./pages/TryOnStudio";
import Library from "./pages/Library";
import DesignsGallery from "./pages/DesignsGallery";
import DesignDetail from "./pages/DesignDetail";
import Collections from "./pages/Collections";
import CollectionDetail from "./pages/CollectionDetail";
import StylesPage from "./pages/StylesPage";
import TeamPage from "./pages/TeamPage";
import TechpacksGallery from "./pages/TechpacksGallery";
import TechpackDetail from "./pages/TechpackDetail";
import CostingGallery from "./pages/CostingGallery";
import CostSheetDetail from "./pages/CostSheetDetail";
import POsGallery from "./pages/POsGallery";
import PurchaseOrderDetail from "./pages/PurchaseOrderDetail";
import LibrariesPage from "./pages/LibrariesPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import Moodboards from "./pages/Moodboards";
import MoodboardEditor from "./pages/MoodboardEditor";
import MoodboardPublic from "./pages/MoodboardPublic";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-6 h-6 border-2 border-black border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/auth" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/board/:shareId" element={<MoodboardPublic />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/studio/sketch" element={<SketchStudio />} />
              <Route path="/studio/materials" element={<MaterialStudio />} />
              <Route path="/studio/collection" element={<CollectionStudio />} />
              <Route path="/studio/bulk" element={<BulkStudio />} />
              <Route path="/studio/tryon" element={<TryOnStudio />} />
              <Route path="/library" element={<Library />} />
              <Route path="/designs" element={<DesignsGallery />} />
              <Route path="/designs/:id" element={<DesignDetail />} />
              <Route path="/collections" element={<Collections />} />
              <Route path="/collections/:id" element={<CollectionDetail />} />
              <Route path="/moodboards" element={<Moodboards />} />
              <Route path="/moodboards/:id" element={<MoodboardEditor />} />
              <Route path="/techpacks" element={<TechpacksGallery />} />
              <Route path="/techpacks/:id" element={<TechpackDetail />} />
              <Route path="/costing" element={<CostingGallery />} />
              <Route path="/costing/:id" element={<CostSheetDetail />} />
              <Route path="/purchase-orders" element={<POsGallery />} />
              <Route path="/purchase-orders/:id" element={<PurchaseOrderDetail />} />
              <Route path="/libraries" element={<LibrariesPage />} />
              <Route path="/styles" element={<StylesPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
